import styled from 'styled-components';

const ContainerForm = styled.div`
  background: #fff;
  width: 100%;
  border-radius: 8px;
  padding: 18px 12px;
  min-height: 160px;
  margin-bottom: 8px;
  border-left: 4px solid #7a959f;
  // border-left: 4px solid #5B36F2;
`;

const TitleForm = styled.div`
  color: #161d1f;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 34px;
`;

const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 40px;
  gap: 16px;
  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

const SaveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 16px;
  background: var(--button-secondary-main);
  border-radius: 4px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  &[disabled] {
    pointer-events: none;
    cursor: none;
    color: #8090bb;
    background: #d5e5f0;
  }

  @media (min-width: 640px) {
    width: auto;
  }

  :hover {
    background: var(--primary-hover);
    color: var(--neutrals-neutral03);
  }

  :focus {
    background: var(--primary-focus);
    color: var(--neutrals-neutral03);
  }

  :active {
    background: var(--primary-focus);
    color: var(--neutrals-neutral03);
  }
`;

const NextButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid var(--button-secondary-main);
  border-radius: 4px;
  color: var(--button-secondary-main);
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  :hover {
    background: var(--button-secondary-hover);
    color: var(--text-primary);
    border-color: var(--interaction-primary);
  }

  :focus {
    background: var(--button-secondary-focus);
    border-color: var(--interaction-primary);
    color: var(--text-primary);
  }

  :active {
    background: var(--button-secondary-focus);
    border-color: var(--interaction-primary);
    color: var(--text-primary);
  }

  @media (min-width: 640px) {
    width: auto;
  }
`;

const DescriptionForm = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  color: var(--text-text02);
  margin-bottom: 24px;
`;

export {
  ContainerForm,
  TitleForm,
  SaveButton,
  NextButton,
  ContainerButtons,
  DescriptionForm
};
